import { FIELD_TRANSLATIONS, USE_API_NULL_VALUE } from '../constants/APIFields'

/**
 * Translate the given filters into their API equivalent.
 * 
 * @param {Object} filters The filters list.
 * @returns {Object} API filters.
 */
const translateFilters = (filters) => {
    let result = {}
    
    for (let [name, value] of Object.entries(filters)) {
        if(value === '' || value === 'Todos' || value === -1) continue
        if(value === USE_API_NULL_VALUE) value = '';

        result[FIELD_TRANSLATIONS[name] || name] = value;
    }

    return result;
}

export default translateFilters;